import script from "./CreatePayStubPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatePayStubPage.vue?vue&type=script&setup=true&lang=js"

import "./CreatePayStubPage.vue?vue&type=style&index=0&id=0e78a51d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e78a51d"]])

export default __exports__